module.exports = __webpack_public_path__ + "static/media/herobg.6337982a.jpg";